import axios from "axios";
import { USER_AU_TOKEN } from "../common/key";
// Use environment variable for backend URL
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// const BACKEND_URL = `https://nke8a81yme.execute-api.us-east-2.amazonaws.com`;

export const BASE_URL = BACKEND_URL;

export const postDataAPI = async (url, post, token) => {
  token = localStorage.getItem(USER_AU_TOKEN);
  const res = await axios.post(`${BASE_URL}/${url}`, post, {
    headers: { Authorization: token },
  });

  return res;
};

export const getDataAPI = async (url, token) => {
  token = localStorage.getItem(USER_AU_TOKEN);
  const res = await axios.get(`${BASE_URL}/${url}`, {
    headers: { Authorization: token },
  });

  return res;
};

export const putDataAPI = async (url, post, token) => {
  token = localStorage.getItem(USER_AU_TOKEN);
  const res = await axios.put(`${BASE_URL}/${url}`, post, {
    headers: { Authorization: token },
  });

  return res;
};
